import BaseEvent from './BaseEvent.js';

class ClearFrontLayerEvent extends BaseEvent {
  handle() {
    this.context._api.clearFrontLayer();
  }
}

export default ClearFrontLayerEvent;
